module.exports = __webpack_public_path__ + "media/images/step-arrow-e9bf64d7.png";